import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class Page implements AnalyticsObject {
  name: string
  properties: PageProperties
  constructor(name: string, properties: PageProperties = { pageCategory: 'generic' }) {
    this.name = `${name} Page`
    this.properties = properties
  }
}

export type PageProperties = AnalyticsProperties &
  Record<string, unknown> & {
    pageCategory?: string
    pageContext?: Record<string, string | null> | 'undefined'
    slices?: string[] | 'undefined'
  }
